import { FilterType } from '../../../context/CommonContext'
import { Task } from '../../../context/BusinessContext'
import { CalendarFold, CalendarX2, ShoppingCart, Tag, User } from 'lucide-react'
import { useProfessional } from '../../../context/ProfessionalContext'
import Avatar from '../Avatar'

export const daysFromToday = (dateStr: string): number => {
    // Divide yyyy-mm-dd manualmente para evitar conversão UTC
    const [year, month, day] = dateStr.split('-').map(Number)

    const today = new Date()
    const target = new Date(year, month - 1, day) // <-- usa fuso local

    today.setHours(0, 0, 0, 0)
    target.setHours(0, 0, 0, 0)

    const diffTime = target.getTime() - today.getTime()
    return Math.round(diffTime / (1000 * 60 * 60 * 24))
}

const TaskPreview = ({ task }: { task: Task }) => {
    const { professionals } = useProfessional()
    const professionalName = professionals.find(
        professional => Number(professional.id) === Number(task.professionalID)
    )?.name
    const professionalImage = professionals.find(
        professional => Number(professional.id) === Number(task.professionalID)
    )?.image

    // define number at days left
    const daysLeft = task.dateNotify ? daysFromToday(task.dateNotify) : 0

    return (
        <div className='flex flex-col gap-1'>
            <div className='flex items-center gap-1 font-semibold'>
                <p className='text-sm'>{task.title}</p>
                <p className={`${task.isExpired ? 'text-red-500' : 'text-success-500'}`}>#{task.id}</p>
                {task.isExpired && <CalendarX2 size={14} className='text-red-500' />}
            </div>
            {task.dateNotify && (
                <div className='flex items-center gap-1'>
                    <CalendarFold size={14} className='text-gray-400' />

                    <p className='text-xs'>
                        {task.dateNotify.slice(8, 10)}/{task.dateNotify.slice(5, 7)}/{task.dateNotify.slice(0, 4)}
                    </p>
                    <p className={daysLeft < 0 ? 'text-red-500' : ''}>
                        {daysLeft === 0
                            ? '(Hoje)'
                            : daysLeft === -1
                              ? '(Ontem)'
                              : daysLeft === 1
                                ? '(Amanhã)'
                                : `(${daysLeft} ${Math.abs(daysLeft) === 1 ? 'dia' : 'dias'})`}
                    </p>
                </div>
            )}

            {/* Professional last note */}
            {professionalName && (
                <div className='flex items-center gap-1'>
                    {professionalImage ? (
                        <Avatar image={professionalImage} name={professionalName} size={5} />
                    ) : (
                        <User size={14} className='text-gray-400' />
                    )}
                    <p className='text-xs'>{professionalName}</p>
                </div>
            )}

            {task.subtitle && <p className='text-xs'>{task.subtitle}</p>}
            {task.subtitle2 && <p className='text-xs'>{task.subtitle2}</p>}
            {task.products && (
                <div className='flex items-center gap-1'>
                    <ShoppingCart size={14} className='text-gray-400' />
                    {task.products.map((product: { id: string; name: string }, index: number) => {
                        return (
                            <span
                                key={index}
                                className='text-[0.65rem] px-2 py-0.5 rounded-lg text-center border dark:border-gray-700 line-clamp-1'
                            >
                                {product.name}
                            </span>
                        )
                    })}
                </div>
            )}
            {task.targets && (
                <div className='flex items-center gap-1'>
                    {task.targets.length > 0 && <Tag size={14} className='text-gray-400' />}
                    {task.targets.map((target: FilterType, index: number) => {
                        return (
                            <span
                                key={index}
                                className='text-[0.65rem] px-2 py-0.5 rounded-lg text-center line-clamp-1'
                                style={{
                                    border: `1px solid ${target.color}`,
                                    color: target.color
                                }}
                            >
                                {target.label}
                            </span>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

export default TaskPreview
